import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/esnext.global-this.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";
import { createStorage as w } from "unstorage";
import { createStore as I, get as u, set as p, del as b, keys as v, clear as S } from "idb-keyval";
import { safeJsonStringify as g, safeJsonParse as d } from "@walletconnect/safe-json";
function C(i) {
  return i;
}
var x = "idb-keyval";
var z = function z() {
  var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var t = i.base && i.base.length > 0 ? "".concat(i.base, ":") : "",
    e = function e(s) {
      return t + s;
    };
  var n;
  return i.dbName && i.storeName && (n = I(i.dbName, i.storeName)), {
    name: x,
    options: i,
    hasItem: function hasItem(s) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return u(e(s), n);
            case 2:
              _context.t0 = typeof _context.sent;
              return _context.abrupt("return", !(_context.t0 > "u"));
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    getItem: function getItem(s) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _yield$u;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return u(e(s), n);
            case 2:
              _context2.t1 = _yield$u = _context2.sent;
              _context2.t0 = _context2.t1 !== null;
              if (!_context2.t0) {
                _context2.next = 6;
                break;
              }
              _context2.t0 = _yield$u !== void 0;
            case 6:
              if (!_context2.t0) {
                _context2.next = 10;
                break;
              }
              _context2.t2 = _yield$u;
              _context2.next = 11;
              break;
            case 10:
              _context2.t2 = null;
            case 11:
              return _context2.abrupt("return", _context2.t2);
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    setItem: function setItem(s, a) {
      return p(e(s), a, n);
    },
    removeItem: function removeItem(s) {
      return b(e(s), n);
    },
    getKeys: function getKeys() {
      return v(n);
    },
    clear: function clear() {
      return S(n);
    }
  };
};
var D = "WALLET_CONNECT_V2_INDEXED_DB",
  E = "keyvaluestorage";
var _ = /*#__PURE__*/function () {
  function _() {
    _classCallCheck(this, _);
    this.indexedDb = w({
      driver: z({
        dbName: D,
        storeName: E
      })
    });
  }
  _createClass(_, [{
    key: "getKeys",
    value: function () {
      var _getKeys = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", this.indexedDb.getKeys());
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getKeys() {
        return _getKeys.apply(this, arguments);
      }
      return getKeys;
    }()
  }, {
    key: "getEntries",
    value: function () {
      var _getEntries = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.t0 = this.indexedDb;
              _context4.next = 3;
              return this.indexedDb.getKeys();
            case 3:
              _context4.t1 = _context4.sent;
              _context4.next = 6;
              return _context4.t0.getItems.call(_context4.t0, _context4.t1);
            case 6:
              return _context4.abrupt("return", _context4.sent.map(function (t) {
                return [t.key, t.value];
              }));
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getEntries() {
        return _getEntries.apply(this, arguments);
      }
      return getEntries;
    }()
  }, {
    key: "getItem",
    value: function () {
      var _getItem = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(t) {
        var e;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return this.indexedDb.getItem(t);
            case 2:
              e = _context5.sent;
              if (!(e !== null)) {
                _context5.next = 5;
                break;
              }
              return _context5.abrupt("return", e);
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function getItem(_x) {
        return _getItem.apply(this, arguments);
      }
      return getItem;
    }()
  }, {
    key: "setItem",
    value: function () {
      var _setItem = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(t, e) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return this.indexedDb.setItem(t, g(e));
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function setItem(_x2, _x3) {
        return _setItem.apply(this, arguments);
      }
      return setItem;
    }()
  }, {
    key: "removeItem",
    value: function () {
      var _removeItem = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(t) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return this.indexedDb.removeItem(t);
            case 2:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function removeItem(_x4) {
        return _removeItem.apply(this, arguments);
      }
      return removeItem;
    }()
  }]);
  return _;
}();
var l = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {},
  c = {
    exports: {}
  };
(function () {
  var i;
  function t() {}
  i = t, i.prototype.getItem = function (e) {
    return this.hasOwnProperty(e) ? String(this[e]) : null;
  }, i.prototype.setItem = function (e, n) {
    this[e] = String(n);
  }, i.prototype.removeItem = function (e) {
    delete this[e];
  }, i.prototype.clear = function () {
    var e = this;
    Object.keys(e).forEach(function (n) {
      e[n] = void 0, delete e[n];
    });
  }, i.prototype.key = function (e) {
    return e = e || 0, Object.keys(this)[e];
  }, i.prototype.__defineGetter__("length", function () {
    return Object.keys(this).length;
  }), typeof l < "u" && l.localStorage ? c.exports = l.localStorage : typeof window < "u" && window.localStorage ? c.exports = window.localStorage : c.exports = new t();
})();
function k(i) {
  var t;
  return [i[0], d((t = i[1]) != null ? t : "")];
}
var K = /*#__PURE__*/function () {
  function K() {
    _classCallCheck(this, K);
    this.localStorage = c.exports;
  }
  _createClass(K, [{
    key: "getKeys",
    value: function () {
      var _getKeys2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              return _context8.abrupt("return", Object.keys(this.localStorage));
            case 1:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function getKeys() {
        return _getKeys2.apply(this, arguments);
      }
      return getKeys;
    }()
  }, {
    key: "getEntries",
    value: function () {
      var _getEntries2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              return _context9.abrupt("return", Object.entries(this.localStorage).map(k));
            case 1:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function getEntries() {
        return _getEntries2.apply(this, arguments);
      }
      return getEntries;
    }()
  }, {
    key: "getItem",
    value: function () {
      var _getItem2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(t) {
        var e;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              e = this.localStorage.getItem(t);
              if (!(e !== null)) {
                _context10.next = 3;
                break;
              }
              return _context10.abrupt("return", d(e));
            case 3:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function getItem(_x5) {
        return _getItem2.apply(this, arguments);
      }
      return getItem;
    }()
  }, {
    key: "setItem",
    value: function () {
      var _setItem2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(t, e) {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              this.localStorage.setItem(t, g(e));
            case 1:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function setItem(_x6, _x7) {
        return _setItem2.apply(this, arguments);
      }
      return setItem;
    }()
  }, {
    key: "removeItem",
    value: function () {
      var _removeItem2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(t) {
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              this.localStorage.removeItem(t);
            case 1:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function removeItem(_x8) {
        return _removeItem2.apply(this, arguments);
      }
      return removeItem;
    }()
  }]);
  return K;
}();
var N = "wc_storage_version",
  y = 1,
  O = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(i, t, e) {
      var n, s, a, m, r, o, f;
      return _regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) switch (_context13.prev = _context13.next) {
          case 0:
            n = N;
            _context13.next = 3;
            return t.getItem(n);
          case 3:
            s = _context13.sent;
            if (!(s && s >= y)) {
              _context13.next = 7;
              break;
            }
            e(t);
            return _context13.abrupt("return");
          case 7:
            _context13.next = 9;
            return i.getKeys();
          case 9:
            a = _context13.sent;
            if (a.length) {
              _context13.next = 13;
              break;
            }
            e(t);
            return _context13.abrupt("return");
          case 13:
            m = [];
          case 14:
            if (!a.length) {
              _context13.next = 28;
              break;
            }
            r = a.shift();
            if (r) {
              _context13.next = 18;
              break;
            }
            return _context13.abrupt("continue", 26);
          case 18:
            o = r.toLowerCase();
            if (!(o.includes("wc@") || o.includes("walletconnect") || o.includes("wc_") || o.includes("wallet_connect"))) {
              _context13.next = 26;
              break;
            }
            _context13.next = 22;
            return i.getItem(r);
          case 22:
            f = _context13.sent;
            _context13.next = 25;
            return t.setItem(r, f);
          case 25:
            m.push(r);
          case 26:
            _context13.next = 14;
            break;
          case 28:
            _context13.next = 30;
            return t.setItem(n, y);
          case 30:
            e(t);
            j(i, m);
          case 32:
          case "end":
            return _context13.stop();
        }
      }, _callee13);
    }));
    return function O(_x9, _x10, _x11) {
      return _ref.apply(this, arguments);
    };
  }(),
  j = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(i, t) {
      return _regeneratorRuntime.wrap(function _callee15$(_context15) {
        while (1) switch (_context15.prev = _context15.next) {
          case 0:
            t.length && t.forEach( /*#__PURE__*/function () {
              var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(e) {
                return _regeneratorRuntime.wrap(function _callee14$(_context14) {
                  while (1) switch (_context14.prev = _context14.next) {
                    case 0:
                      _context14.next = 2;
                      return i.removeItem(e);
                    case 2:
                    case "end":
                      return _context14.stop();
                  }
                }, _callee14);
              }));
              return function (_x14) {
                return _ref3.apply(this, arguments);
              };
            }());
          case 1:
          case "end":
            return _context15.stop();
        }
      }, _callee15);
    }));
    return function j(_x12, _x13) {
      return _ref2.apply(this, arguments);
    };
  }();
var h = /*#__PURE__*/function () {
  function h() {
    var _this = this;
    _classCallCheck(this, h);
    this.initialized = !1, this.setInitialized = function (e) {
      _this.storage = e, _this.initialized = !0;
    };
    var t = new K();
    this.storage = t;
    try {
      var e = new _();
      O(t, e, this.setInitialized);
    } catch (_unused) {
      this.initialized = !0;
    }
  }
  _createClass(h, [{
    key: "getKeys",
    value: function () {
      var _getKeys3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              _context16.next = 2;
              return this.initialize();
            case 2:
              return _context16.abrupt("return", this.storage.getKeys());
            case 3:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this);
      }));
      function getKeys() {
        return _getKeys3.apply(this, arguments);
      }
      return getKeys;
    }()
  }, {
    key: "getEntries",
    value: function () {
      var _getEntries3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              _context17.next = 2;
              return this.initialize();
            case 2:
              return _context17.abrupt("return", this.storage.getEntries());
            case 3:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this);
      }));
      function getEntries() {
        return _getEntries3.apply(this, arguments);
      }
      return getEntries;
    }()
  }, {
    key: "getItem",
    value: function () {
      var _getItem3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(t) {
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              _context18.next = 2;
              return this.initialize();
            case 2:
              return _context18.abrupt("return", this.storage.getItem(t));
            case 3:
            case "end":
              return _context18.stop();
          }
        }, _callee18, this);
      }));
      function getItem(_x15) {
        return _getItem3.apply(this, arguments);
      }
      return getItem;
    }()
  }, {
    key: "setItem",
    value: function () {
      var _setItem3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(t, e) {
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              _context19.next = 2;
              return this.initialize();
            case 2:
              return _context19.abrupt("return", this.storage.setItem(t, e));
            case 3:
            case "end":
              return _context19.stop();
          }
        }, _callee19, this);
      }));
      function setItem(_x16, _x17) {
        return _setItem3.apply(this, arguments);
      }
      return setItem;
    }()
  }, {
    key: "removeItem",
    value: function () {
      var _removeItem3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(t) {
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              _context20.next = 2;
              return this.initialize();
            case 2:
              return _context20.abrupt("return", this.storage.removeItem(t));
            case 3:
            case "end":
              return _context20.stop();
          }
        }, _callee20, this);
      }));
      function removeItem(_x18) {
        return _removeItem3.apply(this, arguments);
      }
      return removeItem;
    }()
  }, {
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21() {
        var _this2 = this;
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              _context21.t0 = this.initialized;
              if (_context21.t0) {
                _context21.next = 4;
                break;
              }
              _context21.next = 4;
              return new Promise(function (t) {
                var e = setInterval(function () {
                  _this2.initialized && (clearInterval(e), t());
                }, 20);
              });
            case 4:
            case "end":
              return _context21.stop();
          }
        }, _callee21, this);
      }));
      function initialize() {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
  }]);
  return h;
}();
export { h as KeyValueStorage, h as default };